import type { Language } from "./types.js";
import { LANGUAGES } from "./types.js";

export function detectLanguage(acceptLanguage: string | null, fallback: Language = "ko"): Language {
  if (!acceptLanguage) return fallback;
  const preferred = acceptLanguage
    .split(",")
    .map((part) => {
      const [lang, q] = part.trim().split(";q=");
      return { lang: lang?.trim().toLowerCase() ?? "", q: parseFloat(q ?? "1") };
    })
    .sort((a, b) => b.q - a.q);

  for (const { lang } of preferred) {
    if (lang.startsWith("ko")) return "ko";
    if (lang.startsWith("zh")) return "zh";
    if (lang.startsWith("ja")) return "ja";
    if (lang.startsWith("en")) return "en";
  }
  return fallback;
}

export function parseQueryLang(query: string | null): Language | null {
  if (!query) return null;
  const lower = query.toLowerCase();
  if ((LANGUAGES as string[]).includes(lower)) return lower as Language;
  return null;
}
